

import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import ButtonOutline from '../../componentes/ui/ButtonOutline';


function ClientReferences({ articleId, articleName }) {
    const [references, setReferences] = useState([{ id: Date.now(), value: '' }]);
    const [existingReferences, setExistingReferences] = useState([]);

    const isEnabled = !!articleId;

    // Simulación de carga de referencias existentes
    useEffect(() => {
        if (articleId) {
            // Aquí iría la llamada real al backend
            console.log(`Cargando referencias para artículo ${articleId}`);
            // Mock data
            setExistingReferences([
                { id: 1, referencia: 'REF-EXISTENTE-01' },
                { id: 2, referencia: 'REF-EXISTENTE-02' }
            ]);
        } else {
            setExistingReferences([]);
        }
    }, [articleId]);

    const handleAddReference = () => {
        setReferences([...references, { id: Date.now() + Math.random(), value: '' }]);
        console.log("Agregar referencia:", { id: Date.now() + Math.random(), value: '' });
    };

    const handleRemoveReference = (id) => {
        setReferences(references.filter(ref => ref.id !== id));

    };

    const handleChange = (id, value) => {
        const newReferences = references.map(ref => 
            ref.id === id ? { ...ref, value } : ref
        );
        setReferences(newReferences);
    };

    const handleDeleteExistingReference = (id) => {
        console.log("Eliminar referencia existente con ID:", id);
        // Aquí iría la lógica para borrar del backend y luego actualizar el estado

        //borra en front
         setExistingReferences(existingReferences.filter(ref => ref.id !== id));
    };

    return (
        <Container className="mt-3">
            {isEnabled && existingReferences.length > 0 && (
                <div className="mb-4">
                    <h5>Referencias Existentes en {articleName || 'artículo'}</h5>
                    <Table striped bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>Referencia</th>
                                <th style={{ width: '100px' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {existingReferences.map((ref) => (
                                <tr key={ref.id}>
                                    <td>{ref.referencia}</td>
                                    <td>
                                        <Button 
                                            variant="outline-danger" 
                                            size="sm" 
                                            title="Eliminar"
                                            onClick={() => handleDeleteExistingReference(ref.id)}
                                        >
                                            <i className="fas fa-trash-alt" color="danger"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            )}

            <h5 className="mb-3">Añadir Nuevas Referencias</h5>
            <Form>
                {references.map((ref, index) => (
                    <Row key={ref.id} className="mb-3 align-items-end">
                        <Col xs={10} md={6}>
                            <Form.Group controlId={`reference-${ref.id}`}>
                                <Form.Label>Referencia Freiremar para {articleName || 'artículo'}</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    placeholder={isEnabled ? "Ingrese referencia" : "Seleccione un artículo primero"} 
                                    value={ref.value}
                                    onChange={(e) => handleChange(ref.id, e.target.value)}
                                    disabled={!isEnabled}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={2} md={6}>
                            {references.length > 1 && (
                                <Button 
                                    variant="outline-danger" 
                                    onClick={() => handleRemoveReference(ref.id)}
                                    className="mb-1"
                                    disabled={!isEnabled}
                                >
                                    <i className="fas fa-trash-alt"></i>
                                </Button>
                            )}
                        </Col>
                    </Row>
                ))}
                
                <div className="mt-3">
                    <Button 
                        variant="outline-success" 
                        onClick={handleAddReference} 
                        className="me-2"
                        disabled={!isEnabled}
                    >
                        <i className="fas fa-plus"></i>
                    </Button>                   
                </div>
            </Form>
        </Container>
    );
}

export default ClientReferences;